var map = {
	"./nav-list.de-CH.json": 1042,
	"./nav-list.de-DE.json": 1043,
	"./nav-list.en-CA.json": 1044,
	"./nav-list.en-GB.json": 1045,
	"./nav-list.en-IN.json": 1046,
	"./nav-list.en-ME.json": 1047,
	"./nav-list.en-US.json": 1048,
	"./nav-list.es-EM.json": 1049,
	"./nav-list.es-ES.json": 1050,
	"./nav-list.fr-BE.json": 1051,
	"./nav-list.fr-CA.json": 1052,
	"./nav-list.fr-CH.json": 1053,
	"./nav-list.nl-BE.json": 1054,
	"./nav-list.nl-NL.json": 1055,
	"./nav-list.pl-PL.json": 1056,
	"./nav-list.pt-BR.json": 1057
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1041;